var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Enviar expediente #" + _vm.file.numero + " a DocDigital",
        size: "lg",
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 text-center" }, [
            _c("h3", [
              _vm._v(
                " Estás a punto de enviar el expediente hacia DocDigital, una vez enviado no habrá vuelta atrás "
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _vm.matterEmpty
                ? _c(
                    "b-form-group",
                    {
                      attrs: { label: "Materia", "label-for": "matter-input" }
                    },
                    [
                      _c("b-form-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:150",
                            expression: "'required|max:150'"
                          }
                        ],
                        attrs: {
                          id: "matter-input",
                          "data-vv-scope": "send-to-docdigital-form",
                          "data-vv-name": "matter",
                          "data-vv-as": "Materia",
                          placeholder: "Ejemplo: Recaudo de impuestos",
                          maxlength: 150,
                          rows: "2",
                          "max-rows": "4"
                        },
                        model: {
                          value: _vm.matterInput,
                          callback: function($$v) {
                            _vm.matterInput = $$v
                          },
                          expression: "matterInput"
                        }
                      }),
                      _c(
                        "small",
                        {
                          staticClass: "form-text text-muted text-right d-block"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.matterInput.length) + " / 150 "
                          )
                        ]
                      ),
                      _c("b-form-invalid-feedback", [
                        _vm._v(
                          " La materia es obligatoria (máximo 150 caracteres). "
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 text-right  mt-5" },
            [
              _c(
                "b-button",
                {
                  attrs: { "data-cy": "send-docdigital", variant: "primary" },
                  on: { click: _vm.sendExpToDocDigital }
                },
                [_vm._v(" Enviar a DocDigital ")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }